import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-82eadc60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "Zone"
};
import BaseRule from "../BaseRule.vue";
import { computed, ref } from "vue";
export default {
  __name: 'Industry',
  props: ["index", "item", "data"],
  setup(__props) {
    const props = __props;
    const data = computed(() => props.data);
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const word = {
      name: "Industry"
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index),
        data: _unref(data)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          type: "textarea",
          modelValue: _unref(item).value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value = $event),
          rows: 5,
          placeholder: "请输入禁入行业，以逗号分隔",
          class: "content"
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["index", "data"]);
    };
  }
};